module.exports = __webpack_public_path__ + "static/media/bogota-7.1cb1cd71.jpg";